/* eslint-disable jsx-a11y/anchor-has-content */

import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { getMarketNftsLive } from '../../utils/wallet';

const Card = (props) => {
    return (
        <div className="col">
            <div className="card h-100">
                <img src={props.img} className="card-img-top" alt="..." />
                <div className="card-body">
                    <h5 className="card-title">{props.name}</h5>
                    <p className="card-text">{props.description}</p>
                    <p>
                        {/* <a aria-label='link' style={{ color: 'red' }} href={"/nightmares/" + parseInt(props.token_id)} alt={'link'}>{"more"}</a> */}
                        <a aria-label='link' href={"/nightmares/" + parseInt(props.token_id)} alt={'link'}>{'more'}</a>
                    </p>
                </div>
            </div>
        </div>

    );
};

const Market = () => {
    //const loaded = useSelector(selectLoaded);
    //const storage = useSelector(selectStorage);
    //const [loaded, setLoaded] = useState(true);
    const [nfts, setNfts] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const func = async () => {
            let tokens = [];
            const marketNfts = await getMarketNftsLive();
            // console.log(marketNfts)
            for (let i = 0; i < marketNfts.length; i++) {
                if (marketNfts[i].url) {
                    let token = {};
                    token.token_id = marketNfts[i].token_id;
                    const response = await axios.get('https://ipfs.io/ipfs/' + marketNfts[i].url);
                    let data = response.data;
                    // console.log('data',data);
                    token.name = data.name;
                    token.description = data.description;
                    if (data.displayUri) token.img = 'https://ipfs.io/ipfs/' + data.displayUri.slice(7);
                    tokens.push(token);
                }
            }
            setNfts(tokens);
            console.log('FINSIHED getting user market place nfts');
            setLoading(false);
        };
        console.log('START getting user market place nfts');
        func();
        //setLoading(true);

        // eslint-disable-next-line
    }, []);

    return (
        <section className="our-offer" id="theOffer">
            <div className="container">
                {loading ? <div style={{ width: '100%', height: '2000px', background: 'transparent' }}>
                    <div className='centerLoader'>
                        <span className="spinner-border spinner-border-lg" role="status" aria-hidden="true"></span>
                    </div>
                </div>
                    : <>
                        <div className="row">

                            {loading ? <div style={{ width: '100%', height: '2000px', background: 'transparent' }}>
                                <div className='centerLoader'>
                                    <span className="spinner-border spinner-border-lg" role="status" aria-hidden="true"></span>
                                </div>
                            </div>
                                : <>
                            <div className="col-lg-12">
                                <div className="section-heading market">
                                    <h1><a href="https://objkt.com/collection/KT1N2DpaCCiK9VyGcj7ohqN9AAQSQJe5oTKL" >Nightmare NFTs</a></h1>
                                    {/* <p><a href="https://objkt.com/collection/KT1A1roCqgNhmdUWgv6XTtNupHNxRcf7Dmty" >Trade on objkt.com</a></p> */}
                                    <p>&nbsp;</p>
                                </div>
                            </div>



                                    <div className="row">
                                        <div className="col-lg-12">

                                            <div className="row row-cols-1 row-cols-md-3 g-4">
                                                {nfts.map((nft, index) => {
                                                    return <Card {...nft} key={index} />;
                                                })}
                                            </div>

                                        </div>
                                    </div>

                                </>}
                        </div>
                    </>}
            </div>
        </section>









    );
};

export default Market;
